import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { IntlProviderWrapper } from "./utility/context/Internationalization";
import { Layout } from "./utility/context/Layout";
import * as serviceWorker from "./serviceWorker";
import { store } from "./redux/storeConfig/store";
import Spinner from "./components/@vuexy/spinner/Fallback-spinner";
import "./index.scss";

const LazyApp = lazy(() => import("./App"));

// Nejprve načti konfiguraci
fetch("/config.json")
  .then(response => response.json())
  .then(config => {
    window.appConfig = config;

    // Po načtení konfigurace vykresli aplikaci
    ReactDOM.render(
      <Provider store={store}>
        <Suspense fallback={<Spinner />}>
          <Layout>
            <IntlProviderWrapper>
              <LazyApp />
            </IntlProviderWrapper>
          </Layout>
        </Suspense>
      </Provider>,
      document.getElementById("root")
    );

    // Registrace service workeru
    serviceWorker.register();
  })
  .catch(error => {
    console.error("Chyba při načítání konfigurace:", error);
  });